import { render, staticRenderFns } from "./video-stream.vue?vue&type=template&id=3f009178&scoped=true&"
import script from "./video-stream.vue?vue&type=script&setup=true&lang=ts&"
export * from "./video-stream.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./video-stream.vue?vue&type=style&index=0&id=3f009178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f009178",
  null
  
)

export default component.exports